import * as Sentry from '@sentry/astro';

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_CLIENT_DSN,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskSensitives: false,
      maskAllInputs: false,
      blockAllMedia: false,
      // Przechwytuj szczegóły requestów/response dla wszystkich API
      networkDetailAllowUrls: [window.location.origin, /^https:\/\//, /^http:\/\//],
      networkCaptureBodies: true,
      networkRequestHeaders: ['content-type', 'x-request-id', 'x-correlation-id'],
      networkResponseHeaders: ['content-type', 'x-request-id', 'x-correlation-id'],
    }),
    Sentry.httpClientIntegration({
      // Przechwytuj szczegóły dla wszystkich HTTP requestów
      failedRequestStatusCodes: [[400, 599]],
    }),
  ],

  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});
